import { render } from "./QuestionModal.vue?vue&type=template&id=34d7e4b8&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"

import "./QuestionModal.vue?vue&type=style&index=0&id=34d7e4b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d7e4b8"]])

export default __exports__